import { render } from "./LabelComponent.vue?vue&type=template&id=178a2543&ts=true"
import script from "./LabelComponent?vue&type=script&lang=ts"
export * from "./LabelComponent?vue&type=script&lang=ts"

import "./assets/_Label.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/runner/work/xebel/xebel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__